import { Input } from '@/components/ui/input'

/** Parses the field: blank is "not set" (null), else whole hours 1–8760; undefined when invalid. */
export function parseHoldTime(value: string): number | null | undefined {
  const v = value.trim()
  if (v === '') return null
  if (!/^\d+$/.test(v)) return undefined
  const n = Number(v)
  return n >= 1 && n <= 8760 ? n : undefined
}

/**
 * A room type's clean hold time (Cleaning Visual, z8nrz7f731): how long a clean
 * holds after its cleaning task is signed off. Drives Released / Expiring /
 * Expired on the Overall View.
 */
export function HoldTimeField({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  const invalid = parseHoldTime(value) === undefined
  return (
    <div className='space-y-1.5'>
      <label htmlFor='clean-hold-time' className='text-xs font-medium text-gray-600'>
        Clean hold time (hours)
      </label>
      <Input
        id='clean-hold-time'
        inputMode='numeric'
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder='e.g. 12'
        className='w-32'
        aria-invalid={invalid || undefined}
      />
      <p className={invalid ? 'text-[11px] text-destructive' : 'text-[11px] text-muted-foreground'}>
        {invalid
          ? 'Whole hours, from 1 to 8760.'
          : 'How long a clean holds once its task is signed off. Rooms show Expiring in the last 4 hours. Blank: no hold time.'}
      </p>
    </div>
  )
}
